import {
  WORKFLOW_FORM_FIELD_INPUT_TYPES,
  WorkflowFormFieldInput,
} from './inputFields/inputField';
import {
  WORKFLOW_FORM_FIELD_OUTPUT_TYPES,
  WorkflowFormFieldOutput,
  WorkflowFormFieldOutputPopulated,
} from './outputFields/outputField';

export type WorkflowFormField =
  WorkflowFormFieldOutput | WorkflowFormFieldInput;

export type WorkflowFormFieldPopulated =
  WorkflowFormFieldOutputPopulated | WorkflowFormFieldInput;

export const WORKFLOW_FORM_FIELD_TYPES = {
  ...WORKFLOW_FORM_FIELD_INPUT_TYPES,
  ...WORKFLOW_FORM_FIELD_OUTPUT_TYPES,
} as const;
